import type { ButtonHTMLAttributes } from 'react';
import { Icon, type IconName } from './icons';

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'aria-label'> & {
  icon: IconName;
  /** Required: an icon-only button has no other accessible name. Also shown as the tooltip. */
  label: string;
};

/** Icon-only button: 32px on desktop, 44px touch target on phone. */
export function IconButton({ icon, label, className, type = 'button', ...rest }: Props) {
  return (
    <button type={type} className={`iconbutton${className ? ` ${className}` : ''}`} aria-label={label} title={label} {...rest}>
      <Icon name={icon} size={18} />
    </button>
  );
}
